import * as React from "react";
import { FeedMessageTypes } from "store/feed/windowMessages";
import { FeedContentUpdate } from "models/ApiModels";
import { PublicationType, PublicationVisility } from "models/ApiEnums";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { MenuItem } from "@mui/material";
import { WindowMessageListener } from "lib/WindowMessageListener";

/////////////////////////////////////////////////////////////////////////////////////////////////


export interface ITimelineDispatchProps {
    onFeedReset: () => void;
    onExpandPublication: (uid: string, publicationId: string) => Promise<void>;
    onUpdateFeedData: (newItemDto: FeedContentUpdate) => void;
    onRemoveFromFeed: (uid: string, publicationId: string) => void;

    onAddPublication?: (publicationId: string) => Promise<void>;
    onReloadPublication?: (uid: string, publicationId: string) => Promise<void>;
    onRemovePublication?: (uid: string, publicationId: string, publicationType: PublicationType) => Promise<boolean>;
    onPublishPublication?: (uid: string, publicationId: string, publicationType: PublicationType) => Promise<boolean>;
    onChangePublicationVisibility?: (uid: string, publicationId: string, visibility: PublicationVisility) => Promise<void>;
    onIgnoreActionRequest?: (uid: string, publicationId: string, actionId: string) => Promise<boolean>;
    onApprovalActionRequest?: (uid: string, publicationId: string, actionId: string, approved: boolean, notes: string) => Promise<boolean>,
    onCustomAction?: (uid: string, publicationId: string, publicationType: PublicationType, action: any) => Promise<boolean>;
    onSidebarResetRequest?: () => void;

    executeFeedMessage?: (messageType: FeedMessageTypes) => void;
}


export class TimelineWindowMessageListener extends WindowMessageListener<FeedMessageTypes> {
}


export function renderMuiMenuItemOrderBy(text: string, opt: any, current: any, applyOrder: Function) {
    return (
        <MenuItem onClick={() => { applyOrder(opt) }}>
            {current == opt && <FontAwesomeIcon fixedWidth icon={faCheck} />}
            {current != opt && <div className="fa fa-check fa-w-16 fa-fw"></div>}
            <span>{text}</span>
        </MenuItem>
    );
}

